import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';

const DropdownContainer = styled.div`
	position: relative;
	width: fit-content;
	min-width: 150px;
`;

const DropdownButton = styled.div`
	padding: 0.2rem 1rem;
	height: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	color: black;
	cursor: pointer;
	font-size: 1.4rem;
	font-family: 'NotoSansKR-Regular';
	transition: all 0.2s ease;
	min-width: 120px;

	&:hover {
		background-color: rgba(200, 200, 200, 0.1);
	}

	.dropdown-text {
		flex: 1;
	}

	.dropdown-arrow {
		margin-left: 8px;
		font-size: 1.2rem;
		transition: transform 0.2s ease;
		color: #666;

		&.open {
			transform: rotate(180deg);
		}
	}
`;

const DropdownList = styled.div`
	position: absolute;
	top: calc(100% + 0.5rem);
	left: 0;
	right: 0;
	background-color: white;
	border-radius: 1.2rem;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
	filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.1));
	z-index: 10000;
	max-height: 240px;
	overflow-y: auto;
	min-width: 150px;
	opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
	visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
	transform: ${({ isOpen }) =>
		isOpen ? 'translateY(0)' : 'translateY(-10px)'};
	transition: all 0.2s ease;

	/* 스크롤바 스타일링 */
	&::-webkit-scrollbar {
		width: 6px;
	}

	&::-webkit-scrollbar-track {
		background: transparent;
		border-radius: 10px;
	}

	&::-webkit-scrollbar-thumb {
		background: #ccc;
		border-radius: 10px;
	}

	&::-webkit-scrollbar-thumb:hover {
		background: #aaa;
	}

	scrollbar-width: thin;
	scrollbar-color: #ccc transparent;
`;

const DropdownItem = styled.div`
	padding: 12px 16px;
	cursor: pointer;
	font-size: 1.4rem;
	font-family: 'NotoSansKR-Regular';
	transition: background-color 0.15s ease;
	color: #333;
	border-radius: 8px;
	margin: 2px 8px;

	&:hover {
		background-color: #f5f5f5;
	}

	&.selected {
		font-weight: 500;
	}

	&.disabled {
		color: #999;
		cursor: not-allowed;
		opacity: 0.6;

		&:hover {
			background-color: transparent;
		}
	}
`;

const UserSelectDropdown = ({
	users,
	onUserSelect,
	selectedUsers = [],
	placeholder = '사용자 선택',
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const dropdownRef = useRef(null);

	// 외부 클릭 감지
	useEffect(() => {
		const handleClickOutside = (event) => {
			if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
				setIsOpen(false);
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
		};
	}, []);

	const handleToggle = () => {
		setIsOpen(!isOpen);
	};

	const handleItemClick = (userId) => {
		// 이미 선택된 사용자인지 확인
		console.log('userId', userId);
		if (selectedUsers.includes(userId)) {
			return;
		}
		onUserSelect(userId);
		setIsOpen(false);
	};

	return (
		<DropdownContainer ref={dropdownRef}>
			<DropdownButton
				onClick={handleToggle}
				className={isOpen ? 'open' : ''}
				selected={false}>
				<span className='dropdown-text'>{placeholder}</span>
				<span className={`dropdown-arrow ${isOpen ? 'open' : ''}`}>▼</span>
			</DropdownButton>
			<DropdownList isOpen={isOpen}>
				{users?.map((user) => {
					const isSelected = selectedUsers.includes(user.id);
					return (
						<DropdownItem
							key={user.id}
							onClick={() => handleItemClick(user.id)}
							className={isSelected ? 'disabled' : ''}>
							{user.name}
							{isSelected && ' (선택됨)'}
						</DropdownItem>
					);
				})}
			</DropdownList>
		</DropdownContainer>
	);
};

export default UserSelectDropdown;
